import './App.css';
import Header from './pages/header';
import Footer from './pages/footer';
import Landingpage from './pages/landingpage';
import Vorstandschaft from './pages/vorstandschaft';
import Garde from './pages/garde';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Kontakt from './pages/kontakt';
import KontaktFormular from './pages/kontaktformular';
import History from './pages/history';
import Prinzenpaare from './pages/pps';
import Impressum from './pages/impressum';
import Galerie from './pages/galerie';

function App() {
  return (
    <div>
      <BrowserRouter>
      <Header/>
        <Routes>
          <Route path="/" element={<Landingpage/>} />
          <Route path="/garde" element={<Garde/>} />
          <Route path="/vorstandschaft" element={<Vorstandschaft/>} />
          <Route path="/kontakt" element={<Kontakt/>} />
          <Route path="/kontaktFormular" element={<KontaktFormular/>} />
          <Route path="/geschichte" element={<History/>} />
          <Route path="/pps" element={<Prinzenpaare/>} />
          <Route path="/impressum" element={<Impressum/>} />
          <Route path="/galerie" element={<Galerie/>} />
        </Routes>
          <Footer/>
      </BrowserRouter>
      </div>
  );
}
export default App;
